import { render, staticRenderFns } from "./Corporates.vue?vue&type=template&id=138b39c9&scoped=true"
import script from "./Corporates.vue?vue&type=script&setup=true&lang=js"
export * from "./Corporates.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138b39c9",
  null
  
)

export default component.exports